/** This plugins is an extension of the highcharts credits. It allows:
 * - to define a specific target for the credits links (for example open link in a new tab)
 * - to show multiple credits (defined as HTML SVG Graphics) */

export default function (H) {
  H.addEvent(H.Chart, 'afterChange', function (e) {
    const chart = e.target
    if (chart.credits) {
      const {href, target='_blank', finCreditUrl, html} = chart.options.credits
      const url = href || finCreditUrl

      if(html){
        chart.credits.update({
          href: '',
        })
        chart.credits.element.innerHTML = html
      }else{
        chart.credits.update({
          finCreditUrl: url,
          href: '',
        })

        chart.credits.element.onclick = function () {
          window.open(
            url,
            target
          )
        }
      }
    }
  })
}
